/*=========================================================================================
  File Name: module-dictionary-actions.js
  Description: Dictionary Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import commonFunc from '@/common/commonFunction';
export default {
	ProvinceList: function(state) {
		return state.ProvinceList;
	},
	DistrictList: function(state) {
		return state.DistrictList;
	},
	WardList: function(state) {
		return state.WardList;
	},
	TaxAgencyList: function(state) {
		return state.TaxAgencyList;
	},
	AllTaxAgencyList: function(state) {
		return state.AllTaxAgencyList;
	},
	TreasuryList: function(state) {
		return state.TreasuryList;
	},
	TreasuryBankList: function(state) {
		return state.TreasuryBankList;
	},
	ChapterList: function(state) {
		return state.ChapterList;
	},
	EconomicsList: function(state) {
		return state.EconomicsList;
	},
	BankList: function(state) {
		return state.BankList;
	},
	Month: function(state) {
		return commonFunc.getDataFromEnum('Month');
	},
	Quarter: function(state) {
		return commonFunc.getDataFromEnum('Quarter');
	},
	Stage: function(state) {
		return commonFunc.getDataFromEnum('Stage');
	},
	TaxAgencyListFilter: function(state) {
		let data = [];
		return state.TaxAgencyList;
	},
	TimesTaxPaid: function(state) {
		return commonFunc.getDataFromEnum('TimesTaxPaidEnum');
	},
	ShowServey: function(state) {
		return state.ShowServey;
	},

	AdminProcedureList: function(state) {
		return state.AdminProcedureList;
	}
};
